export const AnalyticsConfig = {
    trackingId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID
}

console.log(process.env.REACT_APP_GOOGLE_ANALYTICS_ID)